import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PadraoService {
    private relativePath = 'api/';

    constructor(private http: HttpClient) { }

    findById(id): Observable<any> {
        return this.http.get(this.relativePath + id);
    }
}